const date = new Date();
const year = date.getFullYear();
const month = year + '-' + ('0' + (date.getMonth() + 1)).slice(-2);

const ModelAspa = {
  nom: 'aspa',
  type: 'number',
  definition_period: month,
  entity: 'famille',
  imgSrc: 'logo_assurance_retraite.png',
  link: 'https://www.aide-sociale.fr/minimum-retraite-aspa/',
  link2: '#link',
  label: 'Allocation de solidarité aux personnes agées',
  floorAt: 1
};

const getAspaAvailable = (openfisca) => {
  const data = openfisca?.familles?._?.aspa;
  if (data === undefined) {
    return null;
  }

  const value = data[ModelAspa.definition_period];
  if (
    value === undefined ||
    value <= 0 ||
    (ModelAspa.floorAt !== undefined && value < ModelAspa.floorAt)
  ) {
    return null;
  }

  return { ...ModelAspa, value };
};

export { ModelAspa, getAspaAvailable };
